import { useState, useEffect, useCallback, useRef } from "react";
import "../../vendor/vendorList.css";
import "../../../components/common/Util.css";
import { ReactComponent as SearchIc } from "../../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../../assets/svg/down_arror.svg";
import { ReactComponent as DownArrowIc } from "../../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as ThreeDotIC } from "../../../assets/svg/three-dot-ic.svg";
import { ReactComponent as RarIc } from "../../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../../assets/svg/lar_ic.svg";
import profileIc from "../../../assets/png/profile-ic.png";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";

import ReactPaginate from "react-paginate";

import LoaderModal from "../../../components/common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/common/deleteModel";

import "react-datepicker/dist/react-datepicker.css";
import { Sidebar } from "../../../components/common/Sidebar";
import { Navbar } from "../../../components/common/Navbar";
import { ReactComponent as EditIc } from "../../../assets/svg/edit_ic.svg";
import { ReactComponent as CloneIc } from "../../../assets/svg/clone_ic.svg";
import { ReactComponent as DeleteIc } from "../../../assets/svg/delete_ic.svg";
import { useGlobal } from "../../../GlobalContext";
import { deleteProjectApi, getProjectListApi } from "./projectApi";
import DateRangePicker from "../../../components/common/dateRange";
import { format } from "date-fns";
function ProjectNewList() {
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  // variable initial
  const isFirstRender = useRef(true);
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [stageSelect, setStageSelect] = useState({
    value: "",
    label: "All",
  });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [gradeSelect, setGradeSelect] = useState(null);
  const [industrySelect, setIndustrySelect] = useState(null);
  const [citySelect, setCitySelect] = useState(null);
  const [active, setActive] = useState("grid");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stageOption, setStageOption] = useState([]);
  const [stageListOption, setListStageOption] = useState([]);
  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ]);
  const [ProjectList, setProjectList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  // handle

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };
  // useEffect

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // skip first run
    //   return;
    // }
    getProjectList();
  }, [
    itemsPerPage,
    itemOffset,
    startDateSave,
    endDateSave,
    selectedSortby,
    search,
  ]);

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  // Api

  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteProjectApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getProjectList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      } else {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      //   setIsLoading(false);
    }
  };
  const getProjectList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "created",
      "desc",
    ];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getProjectListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setProjectList(response.data.projects ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
        setIsLoading(false);
    }
  };
  return (
    <>
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"vendor"}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteVendor}
      />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Project" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  ">
          {" "}
          <Navbar pageTitle="Project" />
          <div className="bg-half-white p-2">
            <div className="bg-white rounded-4 p-4">
              {" "}
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* Left: Heading */}
                <div className="my-heading fs-24 fw-600">
                  Project - {totalCount}
                </div>

                {/* Right: Controls */}
                <div className="d-flex flex-wrap gap-3">
                  {/* Search */}
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  {/* Add New Vendor */}
                  {checkPermission("Project", "create_permission") && (
                    <div
                      className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => navigate("/project/create")}
                      style={{
                        height: "40px", // Adjust button height if needed
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} />{" "}
                        {/* ✅ Smaller Icon */}
                      </div>

                      <div
                        className="fs-12 fw-600" // ✅ Reduced text size
                        style={{ lineHeight: "16px" }}
                      >
                        New Project
                      </div>
                    </div>
                  )}

                  {/* Import */}
                  {/* <div
                    className="my-import d-flex align-items-center justify-content-center gap-2"
                    style={{ height: "40px", cursor: "pointer" }} // Optional: consistent height
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <ImportIc style={{ width: "16px", height: "16px" }} />{" "}
 
                    </div>

                    <div
                      className="fs-12 fw-600"
                      style={{ lineHeight: "16px" }} // Ensures proper vertical centering
                    >
                      Import
                    </div>
                  </div> */}
                </div>
              </div>
              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex justify-content-start gap-3">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedSortby.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedSortby.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedSortBy(option); // Execute your selection logic
                            }}
                            active={selectedSortby === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div
                    className="d-flex align-items-center px-1"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #EBEBEB",

                      backgroundColor: "white",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span
                      className="dropdown-text1 textPurple mb-2"
                      style={{ height: "28px" }}
                    >
                      {" "}
                      <DateRangePicker onChange={handleDateChange} />
                    </span>
                  </div>{" "}
                </div>
              </div>
            </div>

            <div className="bg-white rounded-4 mt-3 w-100 p-3">
              <div
                style={{
                  display: "flex",
                  flex: "10",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  paddingTop: "16px",
                  height: "40px",
                  backgroundColor: "#F2F2F2",
                }}
                className="head3 w-100 justify-content-center align-items-center"
              >
                {/* <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={handleChange}
                            style={{ marginRight: "8px", marginBottom: "14px" }}
                          /> */}
                <p
                  style={{ width: "127px", flex: "1.5" }}
                  className="fs-13 fw-700 textcolor"
                >
                  Code
                </p>
                <p
                  style={{ width: "160px", flex: "1.5" }}
                  className="fs-13 fw-700 textcolor"
                >
                  Project Name
                </p>
                <p
                  style={{ width: "160px", flex: "2" }}
                  className="fs-13 fw-700 textcolor"
                >
                  Admin
                </p>
                <p
                  style={{ width: "160px", flex: "2" }}
                  className="fs-13 fw-700 textcolor"
                >
                  Manager
                </p>
              </div>
              <div>
                {(ProjectList ?? []).map((item, index) => (
                  <div
                    style={{
                      display: "flex",
                      flex: "10",
                      paddingLeft: "16px",
                      paddingRight: "16px",

                      backgroundColor:
                        hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                      borderBottom: "1px solid #D4DDE7",
                      cursor: "pointer",
                      height: "44px",
                    }}
                    onClick={() => {
                      if (checkPermission("Project", "view_permission")) {
                        navigate("/project/view", {
                          state: { id: item.id },
                        });
                      }
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    className="head3 w-100 justify-content-center align-items-center"
                  >
                    {" "}
                    {/* <input
                                             type="checkbox"
                                             checked={isChecked}
                                             onChange={handleChange}
                                             style={{
                                               marginRight: "8px",
                                               marginBottom: "0px",
                                             }}
                                           /> */}
                    <p
                      className="fs-13 fw-500 textcolor"
                      style={{
                        flex: "1.5",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={item.code}
                    >
                      {item.code ?? "---"}
                    </p>
                    <p
                      className="fs-13 fw-500 textcolor"
                      style={{
                        flex: "1.5",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={item.name}
                    >
                      {item.name ?? "---"}
                    </p>
                    <div
                      className="fs-13 fw-500 textcolor"
                      style={{
                        flex: "2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                      title={item.admin}
                    >
                      <div
                        className="bgLitPrimar rounded-4 me-2 d-flex align-items-center justify-content-center textPurple fs-12 fw-600"
                        style={{ width: "20px", height: "20px" }}
                      >
                        {item.admin && item.admin.trim() !== ""
                          ? item.admin.trim().charAt(0).toUpperCase()
                          : "-"}
                      </div>
                      {item.admin ?? "---"}
                    </div>
                    <p
                      className="fs-13 fw-500 textcolor"
                      style={{
                        flex: "2",
                        display: "flex",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={item.manager}
                    >
                      <div
                        className="bgLitPrimar rounded-4 me-2 d-flex align-items-center justify-content-center textPurple fs-12 fw-600"
                        style={{ width: "20px", height: "20px" }}
                      >
                        {item.manager && item.manager.trim() !== ""
                          ? item.manager.trim().charAt(0).toUpperCase()
                          : "-"}
                      </div>
                      {item.manager ?? "---"}
                    </p>
                    {hoveredIndex === index && (
                      <div
                        style={{
                          position: "absolute",
                          // top: "50%",
                          right: "35px",
                          // transform: "translate(-50%, -50%)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                          }}
                        >
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/project/create", {
                                state: { id: item.id, isClone: true },
                              });
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "28px",
                              height: "28px",
                              borderRadius: "100px",
                              background: "#FFFFFF",
                              cursor: "pointer",
                              border: "0.8px solid #E5E5E5",
                            }}
                          >
                            <CloneIc />
                          </div>{" "}
                          <span style={{ marginLeft: "16px" }}></span>
                          {checkPermission("Project", "edit_permission") && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/project/create", {
                                  state: { id: item.id },
                                });
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                                background: "#FFFFFF",
                                cursor: "pointer",
                                border: "0.8px solid #E5E5E5",
                              }}
                            >
                              <EditIc />
                            </div>
                          )}
                          <span style={{ marginLeft: "16px" }}></span>
                          {checkPermission("Project", "delete_permission") && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteId(item.id);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                                background: "#FFFFFF",
                                cursor: "pointer",
                                border: "0.8px solid #E5E5E5",
                              }}
                            >
                              <DeleteIc />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">
                  Records paer page: &nbsp;
                </span>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
                >
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="my-2"
                  style={{ minWidth: "unset", width: "30%" }}
                >
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default ProjectNewList;
